export enum CalendarScheduleTypeEnum {
  AVAILABILITY,
  BOOKING,
  GROUP_EVENT,
  GOOGLE_EVENT,
  OUTLOOK_EVENT,
}
